import React, { useState } from "react";
import axios from "axios";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/email-illustration.svg";



const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`
const Textarea = styled(Input).attrs({ as: "textarea" })`
  ${tw`h-24`}
`
const EmailLink = styled.a`
  ${tw`inline-block mt-2 text-primary-500 hover:underline`}
`;
const PhoneLink = styled.a`
  ${tw`inline-block mt-2 text-primary-500 hover:underline`}
`;
const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`
const Toast = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 320px;
  max-width: 90%;
  padding: 18px 22px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  z-index: 99999;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  background-color: ${({ type }) =>
    type === "success" ? "rgba(100,21,255,var(--tw-text-opacity))" : "#dc2626"};

  animation: scaleIn 0.35s ease, fadeOut 0.4s ease 2.6s;

  @keyframes scaleIn {
    from {
      transform: translate(-50%, -50%) scale(0.85);
      opacity: 0;
    }
    to {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    to {
      opacity: 0;
    }
  }
`;

const CloseBtn = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  line-height: 1;

  &:hover {
    opacity: 0.8;
  }
`;
export default ({
  subheading = "Contact Us",
  heading = <>Feel free to <span tw="text-primary-500">get in touch</span><wbr /> with us.</>,
  description = "We would love to hear from you! Whether you have a question about our services, pricing, or anything else, our team is ready to answer all your questions.",
  submitButtonText = "Send",
  formAction = "https://vizual-ads.quetzalsads.com/contact.php",
  formMethod = "POST",
  textOnLeft = true,
  email = "rb@vizualads.com",
  whatsapp = "https://wa.me/16122059287",
  phone = "612 205-9287",
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const [popup, setPopup] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPopup("");

    const formData = new FormData(e.target);

    try {
      const res = await axios.post(
        "https://vizual-ads.quetzalsads.com/contact.php",
        formData
      );

      if (res.data.status === "success") {
        setPopup("success");
        e.target.reset();

        // ✅ Auto-close after 3 seconds
        setTimeout(() => setPopup(""), 3000);
      } else {
        setPopup("error");
      }
    } catch (error) {
      setPopup("error");
    }
  };
  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
            <EmailLink href={`mailto:${email}`} target="_blank"><i className="fa-regular fa-envelope"></i> {email}</EmailLink> Or &nbsp;
            <PhoneLink href={whatsapp} target="_blank"><i className="fa-brands fa-whatsapp"></i> {phone}</PhoneLink>
            <Form onSubmit={handleSubmit}>
              <Input type="email" name="email" placeholder="Your Email Address" />
              <Input type="text" name="name" placeholder="Full Name" />
              <Input type="text" name="subject" placeholder="Subject" />
              <Textarea name="message" placeholder="Your Message Here" />
              <SubmitButton type="submit">{submitButtonText}</SubmitButton>
            </Form>
            {/* ================= CENTER TOAST ================= */}
            {popup && (
              <Toast type={popup}>
                <span>
                  {popup === "success"
                    ? "✅ Mail sent successfully"
                    : "❌ Mail sending failed"}
                </span>
                <CloseBtn onClick={() => setPopup("")}>✖</CloseBtn>
              </Toast>
            )}
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
